<template lang="pug">
  vue-range-slider(
    :min="0"
    :max="maxRent"
    tooltip="always"
    :tooltip-formatter="formattedPrice"
    v-model="rent"
    tooltip-placement="bottom"
    :interval="20"
  )
</template>

<script>
import VueRangeSlider from 'vue-slider-component'
import { debounce } from 'lodash'

export default {
  components: { VueRangeSlider },
  props: {
    initialRentMin: {
      type: [Number, String],
      default: null
    },

    initialRentMax: {
      type: [Number, String],
      default: null
    }
  },

  data () {
    return {
      maxRent: null,
      rent: [0, null],
      label: 'Budget'
    }
  },

  watch: {
    rent: debounce(function () {
      if (this.rent[0] === 0) {
        this.$store.commit('deleteParams', 'by_min_rent')
      } else {
        this.$store.commit('updateParams', { key: 'by_min_rent', value: this.rent[0] })
      }

      if (this.rent[1] === this.maxRent) {
        this.$store.commit('deleteParams', 'by_max_rent')
      } else {
        this.$store.commit('updateParams', { key: 'by_max_rent', value: this.rent[1] })
      }

      this.$store.dispatch('searchAccommodations')
        .then(({ budgetizeLabel }) => {
          this.$emit('updated', budgetizeLabel)
        })
    }, 100)
  },

  mounted () {
    this.maxRent = Math.ceil(this.$store.getters.getMaxBudget / 1000) * 1000
    this.rent = [0, this.maxRent]

    if (this.initialRentMin) {
      this.rent = [+this.initialRentMin, this.rent[1]]
    }

    if (this.initialRentMax) {
      this.rent = [this.rent[0], +this.initialRentMax]
    }

    this.$nextTick(() => {
      this.$store.commit('updateReady', 'budgetRange')
    })
  },

  methods: {
    formattedPrice (value) {
      return new Intl.NumberFormat('fr-FR', {
        minimumFractionDigits: 0,
        currency: 'EUR',
        style: 'currency',
        useGrouping: true
      }).format(Math.round(value))
    }
  }
}
</script>
